import React, { Component } from "react";
import { Select, Radio, Space, message, Spin } from "antd";
import Bridge from "../../utils/Bridge";
import { logEvent } from "../../utils/analytics";

const { Option } = Select;

export default class LanguageEducation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_english_first_language: "",
      highest_education: "",
      education_other_specification: "",
      occupation: "",
      house_hold_income: "",
      loading: false,
      if_not_english_first_language: "",
      if_not_english_first_language_other: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Is English your first language?") {
                this.setState({ is_english_first_language: item.value });
              }
              if (item.field == "If not English your first language") {
                this.setState({ if_not_english_first_language: item.value });
              }
              if (
                item.field ==
                "If not English your first language other specification"
              ) {
                this.setState({
                  if_not_english_first_language_other: item.value,
                });
              }
              if (item.field == "Highest level of education?") {
                this.setState({ highest_education: item.value });
              }
              if (
                item.field == "Highest Level Of Education Other Specification"
              ) {
                this.setState({ education_other_specification: item.value });
              }
              if (item.field == "What is your occupation?") {
                this.setState({ occupation: item.value });
              }
              if (item.field == "Total household Income") {
                this.setState({ house_hold_income: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeHighestEducation = (event) => {
    this.setState({
      highest_education: event.target.value,
      education_other_specification: "",
    });
  };
  save = () => {
    if (!this.state.is_english_first_language) {
      message.warning("Please select Is English your first language value");
      return;
    }
    if (!this.state.highest_education) {
      message.warning("Please select Highest Level Of Education");
      return;
    }
    if (this.state.highest_education == "Other") {
      if (!this.state.education_other_specification) {
        message.warning(
          "Please Enter specification of Highest Level Of Education"
        );
        return;
      }
    }
    if (!this.state.occupation) {
      message.warning("Please enter the value of occupation");
      return;
    }
    if (this.state.occupation.length < 5 || this.state.occupation.length > 70) {
      message.warning(
        "Value of Occupation must be between 5 and 70 characters"
      );
      return;
    }
    if (!this.state.house_hold_income) {
      message.warning("Please select House Hold Income.");
      return;
    }
    let questions = [
      {
        parent_field: "Is English your first language?",
        field: "Is English your first language?",
        value: this.state.is_english_first_language,
      },
      {
        parent_field: "If not English your first language",
        field: "If not English your first language",
        value: this.state.if_not_english_first_language,
      },
      {
        parent_field: "If not English your first language other specification",
        field: "If not English your first language other specification",
        value: this.state.if_not_english_first_language_other,
      },
      {
        parent_field: "Highest level of education?",
        field: "Highest level of education?",
        value: this.state.highest_education,
      },
      {
        parent_field: "Highest Level Of Education Other Specification",
        field: "Highest Level Of Education Other Specification",
        value: this.state.education_other_specification,
      },
      {
        parent_field: "What is your occupation?",
        field: "What is your occupation?",
        value: this.state.occupation,
      },
      {
        parent_field: "Total household Income",
        field: "Total household Income",
        value: this.state.house_hold_income,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "3",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "language_education" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(4);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>LANGUAGE, EDUCATION AND OCCUPATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Is English your first language?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    is_english_first_language: e.target.value,
                    if_not_english_first_language: "",
                  })
                }
                value={this.state.is_english_first_language}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <div className="row">
                {this.state.is_english_first_language == "No" && (
                  <div className="col-lg-6">
                    <Select
                      onChange={(value) =>
                        this.setState({ if_not_english_first_language: value })
                      }
                      value={this.state.if_not_english_first_language}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                        marginTop: 20,
                      }}
                    >
                      <Option value="">Select Language:</Option>
                      <Option value="Arabic">Arabic</Option>
                      <Option value="French">French</Option>
                      <Option value="German">German</Option>
                      <Option value="Hindi">Hindi</Option>
                      <Option value="Japanese">Japanese</Option>
                      <Option value="Korean">Korean</Option>
                      <Option value="Mandarin">Mandarin</Option>
                      <Option value="Portuguese">Portuguese</Option>
                      <Option value="Spanish">Spanish</Option>
                      <Option value="Russian">Russian</Option>
                      <Option value="Urdu">Urdu</Option>
                      <Option value="Other">Other</Option>
                    </Select>
                  </div>
                )}
                {this.state.if_not_english_first_language == "Other" && (
                  <div className="col-lg-6">
                    <input
                      type="text"
                      name="if_not_english_first_language_other"
                      placeholder="Enter Language"
                      value={this.state.if_not_english_first_language_other}
                      onChange={(e) => {
                        this.setState({
                          if_not_english_first_language_other: e.target.value,
                        });
                      }}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                        marginTop: 20,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Highest level of education?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeHighestEducation}
                value={this.state.highest_education}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"No formal education"}>
                    No formal education
                  </Radio>
                  <Radio value={"Elementary School"}>Elementary School</Radio>
                  <Radio value={"High school graduate / GED"}>
                    High school graduate / GED
                  </Radio>
                  <Radio value={"Some college, no degree"}>
                    Some college, no degree
                  </Radio>
                  <Radio
                    value={"Associate degree, vocational school, or equivalent"}
                  >
                    Associate degree, vocational school, or equivalent
                  </Radio>
                  <Radio value={"Bachelor's degree"}>Bachelor's degree</Radio>
                  <Radio value={"Master's degree"}>Master's degree</Radio>
                  <Radio value={"Doctorate or Ph.D."}>Doctorate or Ph.D.</Radio>
                  <Radio value={"Other"}>Other</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.highest_education == "Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>{" "}
                </label>
                <br />
                <textarea
                  name="education_other_specification"
                  value={this.state.education_other_specification}
                  onChange={(e) => {
                    this.setState({
                      education_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="mb-2 input-heading">
                What is your occupation? <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="text"
                name="occupation"
                value={this.state.occupation}
                onChange={(e) => this.setState({ occupation: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Total household Income: <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({ house_hold_income: value })
                }
                value={this.state.house_hold_income}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select Household Income:</Option>
                <Option value="Less than $25,000">Less than $25,000</Option>
                <Option value="$25,000 - $49,999">$25,000 - $49,999</Option>
                <Option value="$50,000 - $74,999">$50,000 - $74,999</Option>
                <Option value="$75,000 - $99,999">$75,000 - $99,999</Option>
                <Option value="$100,000 - $149,999">$100,000 - $149,999</Option>
                <Option value="$150,000 - $199,999">$150,000 - $199,999</Option>
                <Option value="$200,000 or more">$200,000 or more</Option>
                <Option value="Prefer not to answer">
                  Prefer not to answer
                </Option>
              </Select>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(2)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
